'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var savedItemSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    SAVED_RECENT_FIRST: 'SAVED_RECENT_FIRST',
    SAVED_OLDEST_FIRST: 'SAVED_OLDEST_FIRST'
});
/*eslint-disable sort-keys */
exports.default = savedItemSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/savedItemSortOrders.js
// module id = H1j4
// module chunks = 60